<template lang="pug">
#reset_password
  .container
    breadcrumb(v-bind:pageName="pageName")
  .container
    p.text-center 更新您的密碼
      br
      | 請輸入8~16位的英數密碼

    form.member_info(@submit="submitForm")
      .row.mt-md-4
        .col-md-6
          span.title 設定密碼
          input.form-control(
            required="true",
            v-model="password",
            type="password",
            placeholder="設定8~16位英數密碼"
          )
        .col-md-6
          span.title 再次輸入密碼
          input.form-control(
            required="true",
            v-model="passwordRepeat",
            type="password",
            placeholder="請再次輸入您的密碼"
          )
        .col-md-12
          hr
      .row.submit-btn.mt-3.justify-content-center
        .col-md-12.text-center
          input.reset_btn(type="submit", value="重設密碼")
  custom-footer
  dialog-success(
    v-if="successDialogShow",
    :title="successDialogTitle",
    :content="successDialogContent"
  )
  dialog-loading(v-if="loadingDialogShow", :content="loadingContent")
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import Breadcrumb from "@/components/common/Breadcrumb";
import { resetPasswordConfirm } from "@/api/user";
import { errorMessage } from "@/utils/message";
import DialogSuccess from "@/components/login/DialogSuccess";
import DialogLoading from "@/components/dialog/DialogLoading";

export default {
  name: "ResetPassword",
  components: {
    "custom-footer": CustomFooter,
    breadcrumb: Breadcrumb,
    "dialog-success": DialogSuccess,
    "dialog-loading": DialogLoading,
  },
  data() {
    return {
      pageName: "重設密碼",
      password: "",
      passwordRepeat: "",
      successDialogShow: false,
      successDialogTitle: "",
      successDialogContent: "",
      loadingDialogShow: false,
      loadingContent: "重設中....",
    };
  },
  created() {
    if (!this.$route.query.user || !this.$route.query.token) {
      this.$router.push({ name: "Home" });
    }
  },
  methods: {
    submitForm(e) {
      e.preventDefault();
      if (this.password !== this.passwordRepeat) {
        errorMessage(this, "資料錯誤", "請確認密碼及再次確認是否相同");
        return;
      }
      this.loadingDialogShow = true;
      let inputData = {
        uid: this.$route.query.user,
        token: this.$route.query.token,
        new_password: this.password,
      };
      resetPasswordConfirm(inputData)
        .then(() => {
          this.loadingDialogShow = false;
          this.resetInputData();
          this.successDialogShow = true;
          this.successDialogTitle = "密碼設定成功";
          this.successDialogContent = "請重新登入會員";
          setTimeout(() => {
            this.successDialogShow = false;
            this.successDialogTitle = "";
            this.successDialogContent = "";
            this.$router.push({ name: "Home" });
          }, 1500);
        })
        .catch((error) => {
          this.loadingDialogShow = false;
          errorMessage(this, "密碼設定失敗", error.response.data.error_msg);
        });
    },
    resetInputData() {
      this.password = "";
      this.passwordRepeat = "";
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/common/input.scss";

#reset_password {
  position: relative;
  height: calc(100vh - 161px);
}

input {
  width: calc(100% - 50px);
}

p {
  text-align: center;
  margin-top: 15px;
  font-size: 1.125rem;
  font-weight: 300;
  margin: 0;
}

hr {
  background-color: #e8e8e8;
  margin-top: 50px;
}
.container {
  position: relative;
}

.member_info {
  max-width: 960px;
  margin: 0 auto;
}

.reset_btn {
  @include rect_radius(100%, 54px, $bg-strength-btn, 4px, #000, 0);
  margin-top: 30px;
  margin-bottom: 230px;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
  cursor: pointer;
  text-align: center;
  line-height: 54px;
  font-size: 20px;
  color: $color_white;
  max-width: 427px;

  &:hover {
    background-color: $c-main-icon;
  }

  p {
    text-align: center;
    line-height: 62px;
    color: white;
  }

  img {
    margin-left: 9px;
  }
}
@media (max-width: 767px) {
  .title {
    margin-top: 20px;
  }

  input {
    width: 100%;
    background-color: white;
  }

  .reset_btn {
    max-width: 100%;
  }
}

@media (max-width: 575px) {
}
</style>
